import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ItaobuySpreadsheet from "../pages/itaobuy-spreadsheet/page";
import ComeFunziona from "../pages/come-funziona-itaobuy/page";
import GuidaPrincipianti from "../pages/itaobuy-guida-principianti/page";
import Confronto from "../pages/confronto/page";
import Prezzi from "../pages/prezzi/page";
import Spedizioni from "../pages/spedizioni/page";
import Pagamenti from "../pages/pagamenti/page";
import Alternative from "../pages/alternative/page";
import GuidaCompleta from "../pages/guida-completa/page";
import Setup from "../pages/setup/page";
import Database from "../pages/database/page";
import Sicurezza from "../pages/sicurezza/page";
import Community from "../pages/community/page";
import Privacy from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/itaobuy-spreadsheet",
    element: <ItaobuySpreadsheet />,
  },
  {
    path: "/come-funziona-itaobuy",
    element: <ComeFunziona />,
  },
  {
    path: "/itaobuy-guida-principianti",
    element: <GuidaPrincipianti />,
  },
  {
    path: "/confronto",
    element: <Confronto />,
  },
  {
    path: "/prezzi",
    element: <Prezzi />,
  },
  {
    path: "/spedizioni",
    element: <Spedizioni />,
  },
  {
    path: "/pagamenti",
    element: <Pagamenti />,
  },
  {
    path: "/alternative",
    element: <Alternative />,
  },
  {
    path: "/guida-completa",
    element: <GuidaCompleta />,
  },
  {
    path: "/setup",
    element: <Setup />,
  },
  {
    path: "/database",
    element: <Database />,
  },
  {
    path: "/sicurezza",
    element: <Sicurezza />,
  },
  {
    path: "/community",
    element: <Community />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;